import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { NewTable, NewTableColumn } from 'shared/components/NewTable';
import { EventModel } from '../models/Evento';
import { EventosColumnVisibility } from '../utils/eventosStorage';

interface Props {
  events: EventModel[];
  total: number;
  page: number;
  rowsPerPage: number;
  isLoading: boolean;
  columnVisibility: EventosColumnVisibility;
  onChangePage: (page: number) => void;
  onChangeRowsPerPage: (rowsPerPage: number) => void;
  onToggleActive: (event: EventModel) => void;
  onDelete: (event: EventModel) => void;
}

const formatDates = (fromDate: string | null, toDate: string | null) => {
  if (!fromDate) {
    return '—';
  }
  const from = moment(fromDate).format('DD MMM YYYY');
  if (!toDate || toDate === fromDate) {
    return from;
  }
  return `${from} - ${moment(toDate).format('DD MMM YYYY')}`;
};

const StatusSwitch = ({
  isActive,
  onClick
}: {
  isActive: boolean;
  onClick: (event: React.MouseEvent) => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={
      'inline-flex h-5 w-9 items-center rounded-full p-0.5 transition ' +
      (isActive ? 'bg-secondary-500' : 'bg-blueGray-200 dark:bg-white/10')
    }
  >
    <span
      className={
        'h-4 w-4 rounded-full bg-white shadow transition-transform ' +
        (isActive ? 'translate-x-4' : 'translate-x-0')
      }
    />
  </button>
);

const EventoTable = ({
  events,
  total,
  page,
  rowsPerPage,
  isLoading,
  columnVisibility,
  onChangePage,
  onChangeRowsPerPage,
  onToggleActive,
  onDelete
}: Props) => {
  const history = useHistory();

  const columns: NewTableColumn<EventModel>[] = [
    {
      key: 'name',
      label: 'Nombre del evento',
      width: {'2xl':'450px', '3xl':'650px'},
      truncate: true,
      render: (event) => (
        <span className="font-semibold text-secondary-600 dark:text-secondary-100">
          {event.name}
        </span>
      )
    },
    {
      key: 'client',
      label: 'Cliente',
      width: {'2xl':'400px', '3xl': '500px'},
      render: (event) => (
        <span className="text-ink dark:text-ink-dark">
          {event.businessClient?.name ?? '—'}
        </span>
      )
    },
    {
      key: 'dates',
      label: 'Fechas',
      width: {'2xl':'350px', '3xl': '450px'},
      render: (event) => (
        <span className="text-ink dark:text-ink-dark">
          {formatDates(event.fromDate, event.toDate)}
        </span>
      )
    },
    {
      key: 'status',
      label: 'Estado',
      align: 'center',
      width: {'2xl':'200px'},
      render: (event) => (
        <StatusSwitch
          isActive={event.isActive}
          onClick={(e) => {
            e.stopPropagation();
            onToggleActive(event);
          }}
        />
      )
    }
  ];

  return (
    <NewTable<EventModel>
      columns={columns}
      columnVisibility={columnVisibility as unknown as Record<string, boolean>}
      data={events}
      getRowKey={(event) => event.id}
      isLoading={isLoading}
      onRowClick={(event) =>
        history.push(`/main/inventories/events/${event.id}`)
      }
      // renderRowActions={(event) => (
      //   <button
      //     type="button"
      //     onClick={(e) => {
      //       e.stopPropagation();
      //       verifyAction({
      //         title: '¿Eliminar este evento?',
      //         body: 'Esta acción elimina el evento de forma permanente.',
      //         onAccept: () => onDelete(event)
      //       });
      //     }}
      //     className="text-inkMuted-dark transition hover:text-red-500"
      //   >
      //     <Trash2 size={15} />
      //   </button>
      // )}
      emptyTitle="No hay eventos para mostrar"
      page={page}
      total={total}
      rowsPerPage={rowsPerPage}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      stickyHeader={{ top: '74px', zIndex: 1 }}
    />
  );
};

export default EventoTable;
